import pluralize from 'pluralize';

const breakSpaceAndCapitalize = (name: string): string => {
  // Handle consecutive uppercase letters (acronyms) - don't separate them
  // Pattern explanation:
  // - (?<![A-Z]) = not preceded by uppercase (negative lookbehind)
  // - (?=[A-Z]) = followed by uppercase (positive lookahead)
  // This adds space before uppercase letters only when they're not part of consecutive uppercase letters
  return name
    .replace(/(?<![A-Z])(?=[A-Z])/g, ' ')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

export const getMetadataLabel = (id: string): string => {
  if (id.includes('__')) {
    return id;
  }
  return breakSpaceAndCapitalize(id);
};

export const getNameWithPlural = (name: string): string => {
  const _name = breakSpaceAndCapitalize(name);
  return pluralize(_name, 4);
};
